import Vue from 'vue'

import FormCheckbox from './FormCheckbox/FormCheckbox'
import FormRadio from './FormRadio/FormRadio'
import FormSwitch from './FormSwitch/FormSwitch'
import FormSelect from './FormSelect/FormSelect'
import FormFieldHolder from './FormFieldHolder/FormFieldHolder'
import FormFieldHolderGroup from './FormFieldHolder/FormFieldHolderGroup'
import FormLabel from './FormLabel/FormLabel'
import FormInput from './FormInput/FormInput'
import FormInputList from './FormInputList/FormInputList'
import FormTextarea from './FormTextarea/FormTextarea'
import FormFieldLine from './FormFieldLine/FormFieldLine'
import FormInfo from './FormInfo/FormInfo'
import FormOptionalLabel from './FormOptionalLabel/FormOptionalLabel'
import FormInputUrl from './FormInputUrl/FormInputUrl'
import FormInputHtmlEncode from './FormInputHtmlEncode/FormInputHtmlEncode'

Vue.component(FormCheckbox.name, FormCheckbox)
Vue.component(FormRadio.name, FormRadio)
Vue.component(FormSwitch.name, FormSwitch)
Vue.component(FormSelect.name, FormSelect)
Vue.component(FormFieldHolder.name, FormFieldHolder)
Vue.component(FormFieldHolderGroup.name, FormFieldHolderGroup)
Vue.component(FormLabel.name, FormLabel)
Vue.component(FormInput.name, FormInput)
Vue.component(FormInputList.name, FormInputList)
Vue.component(FormTextarea.name, FormTextarea)
Vue.component(FormFieldLine.name, FormFieldLine)
Vue.component(FormInfo.name, FormInfo)
Vue.component(FormOptionalLabel.name, FormOptionalLabel)
Vue.component(FormInputUrl.name, FormInputUrl)
Vue.component(FormInputHtmlEncode.name, FormInputHtmlEncode)
